import React, { useState } from "react";
import CollapseCommand from "../Commands/CollapseCommand/CollapseCommand";
import DropDownList from "../DropDownList/DropDownList";
import DropDownListNew from "../DropDownList/DropDownListNew";
import EditCommand from "../Commands/EditCommand/EditCommand";
import DeleteCommand from "../Commands/DeleteCommand/DeleteCommand";
import OpenCommand from "../Commands/OpenCommand/OpenCommand";
import ReduceDashCommand from "../Commands/ReduceDashCommand/ReduceDashCommand";
import Losange from "../Commands/Losange/Losange";
import Rectangle from "../Commands/Rectangle/Rectangle";
import HorizontalLine from "../Commands/HorizontalLine/HorizontalLine";

import VerticalLine from "../Commands/VerticalLine/VerticalLine";
import Circle from "../Commands/Circle/Circle";
import Title from "../Commands/Title/Title";
import MenuDots from "../MenuDots/MenuDots";
import ShortCommand from "../Commands/ShortCommand/ShortCommand";
import "./DiagramItem.css";

export default function DiagramItem(props) {
  const [losangeColumnWith, setLosangeColumnWith] = useState(
    Math.ceil(parseInt(props.losangeWith.slice(0, -2)) * Math.sqrt(2)) + "px"
  );
  const [rectangleColumnWith, setRectangleColumnWith] = useState(
    parseInt(props.rectangleWith.slice(0, -2)) + 2 + "px"
  );
  const [lineBorderWith, setLineBorderWith] = useState(
    (parseInt(props.rectangleWith.slice(0, -2)) + 2) / 4 + "px"
  );
  const [lineWith, setLineWith] = useState(
    (parseInt(props.rectangleWith.slice(0, -2)) + 2) / 2 + "px"
  );

  const [conditionVerticalHeight, setConditionVerticalHeight] = useState(
    parseInt(props.rectangleHeight.slice(0, -2)) + 2 + "px"
  );

  const [
    halfConditionVerticalHeight,
    setHalfConditionVerticalHeight,
  ] = useState(parseInt(props.rectangleHeight.slice(0, -2)) / 2 + 1 + "px");

  const [shortCommandVerticalHeight, setShortCommandVerticalHeight] = useState(
    parseInt(props.shortCommandHeight.slice(0, -2)) + 2 + "px"
  );

  const [
    halfShortCommandVerticalHeight,
    setHalfShortCommandVerticalHeight,
  ] = useState(parseInt(props.shortCommandHeight.slice(0, -2)) / 2 + 1 + "px");
  /*const myLine = useRef();*/
 
  const AddCondition = () => {
    return (
      <div className="tableCondition" style={{ width: "auto", height: "auto" }}>
        <div className="rowCondition" style={{ width: "auto", height: "auto" }}>
          <div
            className="colCondition"
            style={{
              minWidth: rectangleColumnWith,
              maxWidth: rectangleColumnWith,
              visibility: props.leftStep.length > 0 ? "visible" : "hidden",
            }}
          >
            {props.rightStep.length > 0 && (
              <Rectangle
                title={
                  props.leftStep.length > 0
                    ? props.leftStep[0].step.item.item
                    : ""
                }
                rectangleWith={props.rectangleWith}
                rectangleHeight={props.rectangleHeight}
                isDiscontinued={
                  props.leftStep.length > 0
                    ? props.leftStep[0].isDiscontinued
                    : undefined
                }
                isOvale={
                  props.leftStep.length > 0
                    ? props.leftStep[0].isOvale
                    : undefined
                }
                color={
                  props.leftStep.length > 0
                    ? getColor(props.leftStep[0].step.item.id)
                    : undefined
                }
              />
            )}

            {props.leftStep.length > 0 && props.leftStep[0].isReduced && (
              <ShortCommand
                onClickShortCommand={() =>
                  props.onClickShortCommand(props.leftStep[0].step.id)
                }
                title="+"
                width="8px"
                height="8px"
                reduced={props.leftStep[0].isReduced}
              />
            )}
          </div>

          <div
            className="colCondition"
            style={{
              minWidth: lineBorderWith,
              maxWidth: lineBorderWith,
              visibility: props.leftStep.length > 0 ? "visible" : "hidden",
            }}
          >
            <HorizontalLine color="#008dff" width="auto" />
          </div>

          <div
            className="colCondition"
            style={{
              minWidth: lineWith,
              maxWidth: lineWith,
              visibility: props.leftStep.length > 0 ? "visible" : "hidden",
            }}
          >
            {props.leftStep.length > 0 && props.leftStep[0].decision ? (
              <Title
                title={props.leftStep[0].decision.item.item}
                width={lineWith}
              />
            ) : (
              <HorizontalLine color="#008dff" width={lineWith} />
            )}
          </div>

          <div
            className="colCondition"
            style={{
              minWidth: lineBorderWith,
              maxWidth: lineBorderWith,
              visibility: props.leftStep.length > 0 ? "visible" : "hidden",
            }}
          >
            <HorizontalLine color="#008dff" width="auto" />
          </div>

          {props.withCondition ? (
            <div
              className="colCondition"
              style={{
                minWidth: losangeColumnWith,
                maxWidth: losangeColumnWith,
              }}
            >
              {props.menuItems.childs.length > 1 && (
                <Losange
                  title={props.menuItems.step.conditionDescription ? props.menuItems.step.conditionDescription : "Decision ?"}
                  losangeWith={props.losangeWith}
                  losangeHeight={props.losangeHeight}
                />
              )}
            </div>
          ) : (
            <VerticalLine
              color="#008dff"
              height={
                props.bottomSteplength > 0
                  ? conditionVerticalHeight
                  : halfConditionVerticalHeight
              }
            />
          )}

          {!props.withCondition &&
            ((props.rightStep.length > 0 && props.rightStep[0].isReduced) ||
              (props.leftStep.length > 0 && props.leftStep[0].isReduced)) && (
              <VerticalLine
                color="#008dff"
                height={
                  props.bottomSteplength > 0
                    ? shortCommandVerticalHeight
                    : halfShortCommandVerticalHeight
                }
              />
            )}

          <div
            className="colCondition"
            style={{
              minWidth: lineBorderWith,
              maxWidth: lineBorderWith,
              visibility: props.rightStep.length > 0 ? "visible" : "hidden",
            }}
          >
            <HorizontalLine color="#008dff" width="auto" />
          </div>

          <div
            className="colCondition"
            style={{
              minWidth: lineWith,
              maxWidth: lineWith,
              visibility: props.rightStep.length > 0 ? "visible" : "hidden",
            }}
          >
            {props.rightStep.length > 0 && props.rightStep[0].decision ? (
              <Title
                title={props.rightStep[0].decision.item.item}
                width={lineWith}
              />
            ) : (
              <HorizontalLine color="#008dff" width={lineWith} />
            )}
          </div>

          <div
            className="colCondition"
            style={{
              minWidth: lineBorderWith,
              maxWidth: lineBorderWith,
              visibility: props.rightStep.length > 0 ? "visible" : "hidden",
            }}
          >
            <HorizontalLine color="#008dff" width="auto" />
          </div>

          <div
            className="colCondition"
            style={{
              minWidth: rectangleColumnWith,
              maxWidth: rectangleColumnWith,
              visibility: props.rightStep.length > 0 ? "visible" : "hidden",
            }}
          >
            {props.rightStep.length > 0 && (
              <Rectangle
                title={
                  props.rightStep.length > 0
                    ? props.rightStep[0].step.item.item
                    : ""
                }
                rectangleWith={props.rectangleWith}
                rectangleHeight={props.rectangleHeight}
                isDiscontinued={
                  props.rightStep.length > 0
                    ? props.rightStep[0].isDiscontinued
                    : undefined
                }
                isOvale={
                  props.rightStep.length > 0
                    ? props.rightStep[0].isOvale
                    : undefined
                }
                color={
                  props.rightStep.length > 0
                    ? getColor(props.rightStep[0].step.item.id)
                    : undefined
                }
              />
            )}
            {props.rightStep.length > 0 && props.rightStep[0].isReduced && (
              <ShortCommand
                onClickShortCommand={() =>
                  props.onClickShortCommand(props.rightStep[0].step.id)
                }
                title="+"
                width="8px"
                height="8px"
                reduced={props.rightStep[0].isReduced}
              />
            )}
          </div>
        </div>
      </div>
    );
  };

  const getColor = (id) => {
    var color = props.treeColors
      .filter((color) => color.id == id)
      .map((item) => item.color);

    if (color.length == 0) color = props.treeColors[0].color;
    else color = color[0];

    return color;
  };

  return (
    <div>
      {!props.start && (
        <VerticalLine color="#008dff" height={props.verticalLineHeight} />
      )}
      {props.menuItems.decision && (
        <Title title={props.menuItems.decision.item.item} width={lineWith} />
      )}
      {!props.start && (
        <VerticalLine color="#008dff" height={props.verticalLineHeight} />
      )}
      <Rectangle
        title={props.menuItems.step.item.item}
        rectangleWith={props.rectangleWith}
        rectangleHeight={props.rectangleHeight}
        isDiscontinued={props.menuItems.isDiscontinued}
        isOvale={props.menuItems.isOvale}
        color={getColor(props.menuItems.step.item.id)}
      />

      {(props.menuItems.childs.length > 0 || props.menuItems.isReduced) && (
        <ShortCommand
          onClickShortCommand={() =>
            props.onClickShortCommand(props.menuItems.step.id)
          }
          width="8px"
          height="8px"
          reduced={props.reduceds.includes(props.menuItems.step.id)}
        />
      )}
      {props.menuItems.childs.length > 1 && (
        <VerticalLine color="#008dff" height={props.verticalLineHeight} />
      )}

      {props.menuItems.childs.length > 1 && AddCondition()}

      {props.bottomSteplength > 1 && (
        <VerticalLine color="#008dff" height={props.verticalLineHeight} />
      )}
    </div>
  );
}
